import withRouter from "components/_Common/withRouter";
import React from "react"
import { withTranslation } from "react-i18next";
import { Container, Row, Col } from "reactstrap"
import PropTypes from "prop-types";

const Footer = props => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={12}>
              <p className="m-0 text-center">
                © {new Date().getFullYear()} Institute on Governance. {props.t("Crafted with")}{" "}
                <i className="mdi mdi-heart text-danger" /> {props.t("by Suffescom")}
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

Footer.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(Footer));
